module.exports = "<div>Template</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/herramientas/components/template.html
// module id = 12
// module chunks = 0